export default __webpack_public_path__ + "static/media/AkzidenzGroteskBE-It.8c03bdff.woff";